/**
 * Program credits charged per successful AI generation (aligned with `useCreditsUsed`).
 * All of these are charged by the server when the generation succeeds; the browser only checks
 * the balance up front. Keep `server/functions/lib/programCredits.mts` in sync.
 */
export const PROGRAM_GENERATION_CREDITS = {
  /** Initial transcription / transcript generation */
  transcript: 5,
  /** Regenerate AI analysis pack only (no AssemblyAI / re-transcription) */
  summaryPack: 5,
  /** Deep research article webhook */
  researchArticle: 3,
  /** Magazine or podcast article webhook */
  magazineArticle: 2,
  /** All social posts (one bundle) */
  socialPosts: 5,
} as const;
